<template>
  <div v-if="bookingForms">
    <popup-add-booking-form ref="popupAddBookingForm" />
    <vs-row vs-justify="space-between">
      <vs-col vs-w="6">
        <p>Booking Forms can be embedded into the websites</p>
      </vs-col>
      <div>
        <vs-row>
          <vs-button
            icon="list"
            color="primary"
            class="mr-4"
            @click="onClickViewSubmissions"
            v-if="hasPermission('vp.crm.bookingforms.view')"
          >
            View submissions
          </vs-button>
          <vs-button
            icon="edit"
            class="mr-4"
            color="primary"
            @click="onClickManageProducts"
            v-if="hasPermission('vp.crm.bookingproducts.view')"
          >
            Manage booking products
          </vs-button>
          <vs-button
            icon="add"
            color="primary"
            @click="createNewForm"
            v-if="hasPermission('vp.crm.bookingforms.edit')"
          >
            Add booking form
          </vs-button>
        </vs-row>
      </div>
    </vs-row>

    <vs-row> </vs-row>

    <!-- table -->
    <div class="data-list-container data-list-list-view">
      <vs-table
        ref="table"
        class="mt-8"
        v-model="selected"
        pagination
        maxItems="40"
        :data="bookingForms"
        noDataText="No data"
        @selected="onClicked(selected.id)"
      >
        <div
          slot="header"
          class="flex flex-wrap-reverse items-center flex-grow justify-between"
        >
          <!-- ITEMS PER PAGE -->
        </div>
        <template slot="thead">
          <vs-th>Identifier</vs-th>
          <vs-th>Name</vs-th>
          <vs-th>Public form name</vs-th>
          <vs-th>Last updated</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.id }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">
                  {{ tr.formName }}
                </p>
              </vs-td>
              <vs-td>
                <p class="product-category">
                  {{ tr.publicFormName }}
                </p>
              </vs-td>

              <vs-td>
                <p class="product-category">
                  {{ moment(tr.updatedAction.timestamp).format("DD-MM-YYYY") }}
                </p>
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters } from "vuex";
import PopupAddBookingForm from "./Components/PopupAddBookingForm.vue";

export default {
  components: { PopupAddBookingForm },
  data() {
    return {
      moment,
      selected: [],
    };
  },
  methods: {
    createNewForm() {
      this.$refs.popupAddBookingForm.show();
    },
    onClickManageProducts() {
      this.$router.push({ name: "booking-products" });
    },
    onClickViewSubmissions() {
      this.$router.push({ name: "booking-form-submissions" });
    },
    onClicked(id) {
      this.$router
        .push({
          name: "booking-form",
          params: { id: id },
        })
        .catch((e) => {
          console.log("Profile lookup", e);
        });
    },
  },
  computed: {
    ...mapGetters({
      bookingForms: "bookingForms/bookingForms",
    }),
  },

  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("bookingForms/getAll");
    this.$vs.loading.close();
  },
};
</script>
